module.exports = __webpack_public_path__ + "88feff5e2156e99cdc016b2a159a9e88.MP3";